import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { FC } from "react";
import { useAuthContext } from "../context/authContext";

// places+marker needed by ProjectDetails
const libraries: Libraries = ["places", "geometry", "marker"];

export const useGoogleMaps = (): { isLoaded: boolean; error?: Error } => {
  const auth = useAuthContext();
  // const [isLoaded, setIsLoaded] = useState(false);

  const { isLoaded: apiLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    libraries: libraries,
    language: auth.identity?.language,
  });

  // useEffect(() => {
  //   if (apiLoaded && window.google) {
  //     setIsLoaded(true);
  //   }
  // }, [apiLoaded]);

  // useEffect(() => {
  // window.location.reload(); // TODO show Dialog to user
  // }, [auth.identity?.language]);

  // Optionally, handle errors in loading the Google Maps API
  if (loadError) {
    console.error("Error loading Google Maps API:", loadError);
  }

  return { isLoaded: !!apiLoaded && !!window.google, error: loadError };
};

export const GoogleMapsInitializer: FC = () => {
  useGoogleMaps();
  return undefined;
};
